import APITemplate from '@api/APITemplate'
import con from '@services/connection'
import { URL_INSTANCES } from '@modules/ai-framework/constants/URL'

const ERRO_INESPERADO = 'Erro inesperado. Tente novamente mais tarde.'

function requireId(id) {
  if (id === undefined || id === null || id === '') {
    return {
      status: 400,
      message: 'id da instância obrigatório',
      value: null,
    }
  }
  return null
}

// Cada resource deste módulo declara `location='json'` no reqparse, então toda
// chamada com corpo precisa do opt-in `{ json: true }` — o default do
// `connection.js` é FormData, e `montarFormData` só serializa ARRAYS: objeto
// simples cai no `formData.append(key, value)`, que faz String(value) e envia o
// literal "[object Object]". O backend responde 400 com
// "Value is the wrong type. Type received: <class 'str'>, expected <str, dict>".
// Foi o que quebrou a ativação de agente (`variables` e `canais` chegavam assim).
const ENVIAR_JSON = { json: true }

// CRUD do parceiro sobre instâncias do escritório (spec-002). Envelope
// { status, message, value } de response.data — status lido pelo caller
// (contrato: response.data.status, nunca o HTTP status).
class APIAiFrameworkInstances extends APITemplate {
  async getInstances() {
    const r = await con.get(URL_INSTANCES)
    return r || this.buildErrorResponse({ message: ERRO_INESPERADO })
  }

  async getInstanceDetail(id) {
    const guard = requireId(id)
    if (guard) return guard
    const r = await con.get(`${URL_INSTANCES}/${id}`)
    return r || this.buildErrorResponse({ message: ERRO_INESPERADO })
  }

  async createInstance(payload = {}) {
    const r = await con.post(URL_INSTANCES, payload, false, ENVIAR_JSON)
    return r || this.buildErrorResponse({ message: ERRO_INESPERADO })
  }

  async updateInstance(id, payload = {}) {
    const guard = requireId(id)
    if (guard) return guard
    const r = await con.put(`${URL_INSTANCES}/${id}`, payload, false, ENVIAR_JSON)
    return r || this.buildErrorResponse({ message: ERRO_INESPERADO })
  }

  async pauseInstance(id) {
    const guard = requireId(id)
    if (guard) return guard
    const r = await con.post(`${URL_INSTANCES}/${id}/pause`)
    return r || this.buildErrorResponse({ message: ERRO_INESPERADO })
  }

  async resumeInstance(id) {
    const guard = requireId(id)
    if (guard) return guard
    const r = await con.post(`${URL_INSTANCES}/${id}/resume`)
    return r || this.buildErrorResponse({ message: ERRO_INESPERADO })
  }

  async migrateInstanceVersion(id, payload = {}) {
    const guard = requireId(id)
    if (guard) return guard
    const r = await con.post(
      `${URL_INSTANCES}/${id}/migrate-version`, payload, false, ENVIAR_JSON,
    )
    return r || this.buildErrorResponse({ message: ERRO_INESPERADO })
  }
}

// Singleton no padrão do projeto: instância nomeada + export explícito.
// A classe NÃO é exportada — ninguém a consome (verificado por grep em src/),
// e export sem consumidor é código morto que o próximo leitor tenta preservar.
const apiAiFrameworkInstances = new APIAiFrameworkInstances()

export { apiAiFrameworkInstances }
